import type { RouteObject } from 'react-router';
import { CookPage } from './CookPage';
import { PlanAutoPage } from './PlanAutoPage';
import { PlanDetailPage } from './PlanDetailPage';
import { PlanMyWeekPage } from './PlanMyWeekPage';
import { PlanPrintPage } from './PlanPrintPage';
import { PlanWeekPage } from './PlanWeekPage';

/** Routes for the meal-plan area (calendar, timeline, cooking mode). Mounted inside RequireHousehold. */
export const plansRoutes: RouteObject[] = [
  { path: '/plan', element: <PlanWeekPage /> },
  // Static segment: ranks above `/plan/:id`.
  { path: '/plan/week', element: <PlanMyWeekPage /> },
  { path: '/plan/week/auto', element: <PlanAutoPage /> },
  { path: '/plan/:id', element: <PlanDetailPage /> },
  { path: '/plan/:id/cook', element: <CookPage /> },
  { path: '/plan/:id/print', element: <PlanPrintPage /> },
];
